import React from "react";
import Recommendation from "./Recommendation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import { Spin } from "antd";
import "./Recomendations.scss";
import "./RecomendationBox.scss";
import { useTranslation } from "react-i18next";

function Recomendations(props) {
    const { t } = useTranslation();
    return (
        <div className="opt-app__view opt-app__view--recomendations">
            <Spin spinning={props.isLoading}>
                {
                    // When there are recommended
                    props.question || props.searchKnowledge ? (
                        <div className="opt-app__question-answer">
                            {(!props.searchKnowledge || props.searchKnowledge === "") && (
                                <>
                                    <h1 className="opt-app__title">{t("question")}:</h1>
                                    <p className="opt-app__text opt-app__text--red opt-app__text--question">
                                        {props.question}
                                    </p>
                                </>
                            )}
                            <div className="opt-app__recomendations">
                                <div className={`reco-list`}>
                                    {props.recomendations.map((item, index) => (
                                        <Recommendation
                                            key={index}
                                            id={item.sourceId}
                                            content={item.answer}
                                            attachments={item.attachments}
                                            sendRecoCb={props.addLikeCb}
                                        />
                                    ))}
                                    {props.recomendations && props.recomendations.length === 0 && (
                                        <div className="opt-app__not-found answer-not-found">
                                            <FontAwesomeIcon icon={faCommentDots} />
                                            <p className="opt-app__text">{t("noAnswer")}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="opt-app__not-found">
                                <FontAwesomeIcon icon={faCommentDots} />
                                <p className="opt-app__text">{t("noQuestion")}</p>
                            </div>
                        </>
                    )
                }
            </Spin>
        </div>
    );
}
export default Recomendations;
